module.exports = __webpack_public_path__ + "prod/1.42.2/img/arrow-bot.24ebef1d.png";